/**
 * Keep merge logic in sync with app/utils/routeChecklist.util.js
 */
export function normalizeChecklistItemKey(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

export function mergeChecklistResultWithVehicleChecklist(
  vehicleChecklist,
  storedResults
) {
  const results = Array.isArray(storedResults) ? storedResults : [];
  const byKey = new Map();
  for (const entry of results) {
    if (!entry || typeof entry !== "object") continue;
    const label = (entry.item || entry.label || "").toString().trim();
    if (!label) continue;
    const key = normalizeChecklistItemKey(label);
    byKey.set(key, { item: label, result: entry.result === true });
  }

  const template = (Array.isArray(vehicleChecklist) ? vehicleChecklist : [])
    .map((s) => (s != null ? String(s).trim() : ""))
    .filter(Boolean);

  if (template.length === 0) {
    return results
      .filter((e) => e && typeof e === "object")
      .map((e) => ({
        item: (e.item || e.label || "").toString(),
        result: e.result === true,
      }));
  }

  return template.map((itemLabel) => {
    const key = normalizeChecklistItemKey(itemLabel);
    const matched = byKey.get(key);
    return { item: itemLabel, result: matched ? matched.result : false };
  });
}
